import { colors } from 'kaizen-ui-colors/lib';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { IStore } from '../../domain/store/IStore';
import { IUsecase } from '../../application/usecase/IUsecase';
import { RoundMonitorToolbar } from './Toolbar/RoundMonitorToolbar';
import { OrganizationSettingToolbar } from './Toolbar/OrganizationSettingToolbar';
import { elevation4 } from '../sharedStyle/elevation';

interface IProps {
  store?: IStore;
  usecase?: IUsecase;
}

const Wrapper = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background-color: ${colors.mochi__f2f6fa};
  color: currentColor;
  font-weight: bold;
  font-size: 14px;
  ${elevation4};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 56px;
  height: auto;
  padding-right: 24px;
  padding-left: 24px;
  overflow: visible;
`;

declare const Headroom: any;

@inject('store', 'usecase')
@observer
class Toolbar extends React.Component<IProps, {}> {
  private toolbar: HTMLDivElement;
  private store: IStore;
  private usecase: IUsecase;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.usecase = props.usecase!;

    this.renderBlankToolbar = this.renderBlankToolbar.bind(this);
    this.renderOrganizationSettingToolbar = this.renderOrganizationSettingToolbar.bind(this);
    this.renderRoundMonitorToolbar = this.renderRoundMonitorToolbar.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
  }

  public componentDidUpdate() {
    const node = ReactDOM.findDOMNode(this.toolbar) as HTMLInputElement;
    this.initHeadRoom(node);
  }

  private initHeadRoom(node: HTMLElement) {
    if (node) {
      const headroom = new Headroom(node, {
        offset: 0,
        tolerance: 5,
        classes: {
          initial: 'animated',
          pinned: 'slideDown',
          unpinned: 'slideUp',
        },
      });
      headroom.init();
    }
  }

  private renderBlankToolbar() {
    return (
      <Wrapper>
        <Row>
          <div />
        </Row>
      </Wrapper>
    );
  }

  private renderOrganizationSettingToolbar() {
    return (
      <Wrapper>
        <Row>
          <OrganizationSettingToolbar toggleMode={this.toggleMode} />
        </Row>
      </Wrapper>
    );
  }

  private renderRoundMonitorToolbar() {
    return (
      <Wrapper ref={(ref: any) => (this.toolbar = ref)}>
        <Row>
          <RoundMonitorToolbar toggleMode={this.toggleMode} />
        </Row>
      </Wrapper>
    );
  }

  private toggleMode(_: React.MouseEvent<HTMLElement>) {
    const { uiState } = this.store;
    uiState.toggleMode();
  }

  public render() {
    const { uiState, organizationStore } = this.store;

    if (!organizationStore || organizationStore.isLoading) {
      return this.renderBlankToolbar();
    } else {
      if (uiState.mode == 1) {
        return this.renderRoundMonitorToolbar();
      }
      return this.renderOrganizationSettingToolbar();
    }
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/Toolbar.tsx